import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingPet from '../shared/LoadingPet';
import Share from './Share';
import http from '../../libs/http';
import analytics from '../../libs/analytics';
import './style.css';

interface ProgressData {
  totalMessages: number;
  conversationCount: number;
  totalDaysPracticing: number;
  firstMessageAt: string | null;
  lastMessageAt: string | null;
  weeklyStats: {
    messages: number;
    daysActive: number;
    estimatedMinutes: number;
  };
  estimatedMinutesTotal: number;
}

function SharePage({ user }: any) {
  const navigate = useNavigate();
  const [data, setData] = useState<ProgressData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    analytics.progressShareClicked();
    async function fetchProgress() {
      try {
        const url = `${process.env.REACT_APP_API_URL}/api/v1/conversations/progress`;
        const headers = { Authorization: user.token };
        const response = await http.get(url, headers);

        if (response && !response.error) {
          setData(response);
        } else {
          // If no data, redirect back to progress
          navigate('/progresso');
        }
      } catch (err) {
        console.error('Failed to fetch progress for share:', err);
        navigate('/progresso');
      } finally {
        setLoading(false);
      }
    }

    fetchProgress();
  }, [user.token, navigate]);

  if (loading || !data) {
    return <LoadingPet size="large" />;
  }

  const userName = user.name || 'Aluno';

  return (
    <div className="progress-page">
      <Share data={data} userName={userName} />
    </div>
  );
}

export default SharePage;
